export const FORM_TYPE_LABELS: Readonly<Record<string, string>> = {
    assessment: "Assessment",
    hazard: "Hazard",
    incident: "Incident",
    audit: "Audit",
    investigation: "Investigation",
    inspection: "Inspection",
    checklist: "Checklist",
    generalForm: "General",
    confidentialReporting: "Confidential",
};

export function formTypeLabel(formType?: string | null): string {
    const type = formType?.trim();
    if (!type) {
        return "";
    }
    return FORM_TYPE_LABELS[type] ?? type;
}
